import { CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Save } from "react-feather";
import { adminServices } from "../../services/admin.services";
import AlertSnackBar from "../AlertSnackBar/AlertSnackBar";
import CustomButton from "../CustomButton/CustomButton";
import SnackBar from "../SnackBar/SnackBar";
import Underline from "../Underline/Underline";

export const VideoUploader = ({
  setFormChanged,
  setDirty,
  setPristine,
  resubmit,
  setResubmit,
}) => {
  /**Holds the video file */
  const [video, setVideo] = useState(null);

  /**The video file when uploaded is converted to a bolb link to be previewed before saving */
  const [videoPreview, setVideoPreview] = useState(null);

  /**for the load of the preview */
  const [loading, setLoading] = useState(false);

  /**for the laod on save */
  const [buttonLoading, setButtonLoading] = useState(false);

  /**Holds error if any */
  const [error, setError] = useState("");

  /**If video saved successfully */
  const [videoSaved, setVideoSaved] = useState(false);

  const handleVideoInsert = async (e) => {
    /**Handles the insert of a video file */
    setLoading(true);

    /**We save the video and convert it to a blob so we can preview it for the user */
    if (e.target.files[0]) {
      /**If File Size bigger than 200 MB, display an error than file size is too big*/
      if (e.target.files[0].size > 200 * 1048576) {
        setError("Video size too big. Maximum video size: 200MB");
        setLoading(false);
        return;
      }
      setVideo(e.target.files[0]);
      const video_file = e.target.files[0];
      const video_preview_link = await URL.createObjectURL(video_file);
      setFormChanged(true);
      sessionStorage.setItem(
        "unsavedChanges",
        JSON.stringify(true)
      );
      setDirty();
      setVideoPreview(video_preview_link);
    } else {
      /** If no file is inserted, there is no preview*/
      setVideoPreview(null);
    }
    setLoading(false);
  };

  const submitVideo = async () => {
    /**Saving video in the database */
    setButtonLoading(true);
    var formData = new FormData();

    formData.append("File", video);

    await adminServices
      .uploadVideo(formData)
      .then((response) => {
        setVideoSaved(true);
        setFormChanged(false);
        sessionStorage.removeItem("unsavedChanges");
        setPristine();
        setResubmit(!resubmit);
        setButtonLoading(false);
      })
      .catch((error) => {
        setError(error.response.data.error.error);
        setButtonLoading(false);
      });
  };

  /*Handle closing snackBar*/
  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setVideoSaved(false);
  };

  /*Handle Close Alert Snackbar*/
  const handleCloseAlertSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setError("");
  };

  return (
    <div>
      {error !== "" ? (
        <AlertSnackBar
          message={error}
          handleClose={handleCloseAlertSnackbar}
          open={error !== ""}
        />
      ) : null}
      {videoSaved ? (
        <SnackBar
          open={videoSaved}
          message="Saved successfully"
          severity="success"
          handleClose={handleSnackBarClose}
        />
      ) : null}

      <div className="upload-main-div">
        <Grid container style={{ marginBottom: "1em" }}>
          <Grid item lg={6} xl={6} md={8} sm={12} xs={12}>
            <div
              style={{
                display: "block",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h5" component="span">
                Upload a Video:
              </Typography>
              <Underline />
            </div>
          </Grid>
          <Grid item lg={6} xl={6} md={4} sm={12} xs={12}></Grid>
        </Grid>

        <div className="upload-section-1">
          {!loading && videoPreview ? (
            <div className="upload-div-preview">
              <video src={videoPreview} controls></video>
            </div>
          ) : !loading && !videoPreview ? null : (
            <div style={{ textAlign: "center" }} className="upload-div-preview">
              <CircularProgress sx={{ color: "#0077c6" }} />
            </div>
          )}
          <div className="upload-div-file">
            <input
              type="file"
              name="video_upload"
              accept="video/*"
              onChange={handleVideoInsert}
              disabled={buttonLoading}
            />
          </div>
        </div>
        <div className="upload-div-button">
          <CustomButton
            startIcon={<Save />}
            loading={buttonLoading}
            toggle={submitVideo}
          >
            Save Video
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
